import { ComponentType, CSSProperties, FunctionComponent } from 'react';
import classNames from 'classnames';
import { hasFlag } from 'country-flag-icons';
import * as RegularFormat from 'country-flag-icons/react/3x2';
import { Application, CountryCodeType } from '@monorepo/types';
import { Flex } from '../../';
import FiversIcon from './5ers-country.svg?react';
import TtpIcon from './ttp-country.svg?react';

import './country-icon.scss';

export interface CountryIconProps {
  code?: string;
  bordered?: boolean;
  style?: CSSProperties;
  project?: Application;
}

/**
 * Get the icon data based on the country code and project.
 * @param code - The country code for which the icon is needed.
 * @param project - The application project type (default is Application.THE5ERS).
 * EXCEPTIONS_COUNTRY_MAP - A map to handle exceptions for specific country codes.
 */
const getIconData = ({
  code,
  project = Application.THE5ERS,
}: {
  code?: string;
  project?: Application;
}): {
  Icon: ComponentType;

  code?: string;
} => {
  const EXCEPTIONS_COUNTRY_MAP: Partial<
    Record<CountryCodeType, CountryCodeType>
  > = {
    NC: 'FR',
  };

  code = EXCEPTIONS_COUNTRY_MAP[code as CountryCodeType] || code;

  let Icon: ComponentType = project === Application.TTP ? TtpIcon : FiversIcon;

  if (code && hasFlag(code)) {
    Icon = RegularFormat[code as keyof typeof RegularFormat];
  }

  return { Icon, code };
};

export const CountryIcon: FunctionComponent<CountryIconProps> = ({
  code,
  style,
  bordered = true,
  project,
}) => {
  const { Icon } = getIconData({ code, project });

  return (
    <Flex
      style={style}
      align="center"
      justify="center"
      className={classNames('the5ers-country-icon', {
        'the5ers-country-icon--bordered': bordered,
      })}
    >
      <Icon />
    </Flex>
  );
};
